import {InvitationType} from "@app/core-shared";


export const invitationTypeEnumOptions =
  [
    {
      label: 'core-portal.settings.invitations.invitation-types.1',
      value: InvitationType.Identify
    }
  ];
